import type { SearchLocation } from '@/scopes/search/search/infrastructure/api/types';
import * as React from 'react';
import { styled } from 'styled-components';
import { tk, SpaceBetween, Typography } from '@sunwebgroup/ui-components';
import { LazyImage, LazyImageFallback } from '@/scopes/common/components/Image';
import { LocationTag } from './LocationTag';
import { Card } from '../../../../../../../common/components/Card';
import { OverlayLink } from './OverlayLink';
import FavoriteButton from './FavoriteButton';

export interface ProductCardTinyProps {
  id: number;
  accommodationId: number;
  href?: string;
  imageSource: string;
  imageAlt: string;
  locations: SearchLocation[];
  name: string;
  rating: number;
}

export function ProductCardTiny({
  accommodationId,
  href,
  imageSource,
  imageAlt,
  locations,
  name,
}: ProductCardTinyProps) {
  return (
    <StyledProductCardTinyWrapper>
      {href && <OverlayLink href={href} aria-label={name} target="_blank" />}{' '}
      <LazyImage src={imageSource} alt={imageAlt} size="sm" />
      <FavoriteButton productId={accommodationId} />
      <SpaceBetween spacing={tk('spacing_2xs')} direction="y" padding={tk('spacing_md')} justifyContent="center">
        <StyledHeader $variant="heading-md" as="span">
          {name}
        </StyledHeader>
        <LocationTag locations={locations} />
      </SpaceBetween>
    </StyledProductCardTinyWrapper>
  );
}

ProductCardTiny.displayName = 'ProductCardTiny';

const StyledProductCardTinyWrapper = styled(Card)`
  position: relative;
  display: flex;
  height: 109px;
  width: 374px;

  ${LazyImage}, ${LazyImageFallback} {
    flex: 0 0 auto;
    width: 120px;
  }

  ${FavoriteButton} {
    position: absolute;
    top: ${tk('spacing_xs')};
    left: 80px;
  }
`;

const StyledHeader = styled(Typography)`
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
`;
